import { lazy, useEffect } from 'react'
import { Navigate, Route, Routes as RouterRoutes, useLocation } from 'react-router-dom'

import { dataLayerSetPage } from '@dhl/datalayer'
import { NavigateExternal } from '@dhl/utils'
import { MaintenancePage } from '@dhl/maintenance'

import { BasketRoutes } from '~/basket/view/Routes'
import { PATH, EXTERNAL_PATHS } from '~/links'
import { utmQueryString } from '~/util/utmQueryString'
import { DelayedPayment } from '~/basket/view/pages/payment/DelayedPayment'
import { Page } from '~/components/Page'
import { isFeatureEnabled } from '~/config'

const ProfileRoutes = lazy(() => import('~/profile/view/Routes').then((module) => ({ default: module.ProfileRoutes })))
const AddressBookRoutes = lazy(() =>
  import('~/address-book/view/Routes').then((module) => ({ default: module.AddressBookRoutes }))
)
const DashboardRoutes = lazy(() =>
  import('~/dashboard/view/Routes').then((module) => ({ default: module.DashboardRoutes }))
)
const ServicepointMapPage = lazy(() =>
  import('~/servicepoint/ServicepointMapPage').then((module) => ({ default: module.ServicepointMapPage }))
)
const ReportRoutes = lazy(() => import('~/report/Routes').then((module) => ({ default: module.ReportRoutes })))

const externalPathList: string[] = Object.values(EXTERNAL_PATHS)
const ignorePathsForDatalayer: string[] = [
  ...externalPathList.reduce((prev: string[], current: string) => [...prev, `/${current}`], []),
  `/`,
  `/${PATH.BASKET}`,
  `/${PATH.ADDRESS_BOOK}`,
  `/${PATH.DASHBOARD}`,
  `/${PATH.REPORT}`,
]

export const Routes = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (!ignorePathsForDatalayer.includes(pathname)) {
      dataLayerSetPage({ url: pathname })
    }
  }, [pathname])

  if (isFeatureEnabled('maintenance')) {
    return (
      <Page>
        <MaintenancePage />
      </Page>
    )
  }
  return (
    <RouterRoutes>
      {externalPathList.map((path) => (
        <Route key={path} path={path} element={<NavigateExternal to={`/${path}`} />} />
      ))}
      <Route path={PATH.BASKET}>
        <Route index path="*" element={<BasketRoutes />} />
      </Route>
      <Route path={PATH.SERVICEPOINT}>
        <Route index path="*" element={<ServicepointMapPage />} />
      </Route>
      <Route path={PATH.ADDRESS_BOOK}>
        <Route index path="*" element={<AddressBookRoutes />} />
      </Route>
      <Route path={PATH.DASHBOARD}>
        <Route index path="*" element={<DashboardRoutes />} />
      </Route>
      <Route path={PATH.REPORT}>
        <Route index path="*" element={<ReportRoutes />} />
      </Route>
      <Route path={PATH.PROFILE}>
        <Route index path="*" element={<ProfileRoutes />} />
      </Route>
      <Route path={PATH.DELAYED_PAYMENT} element={<DelayedPayment />} />
      <Route index element={<Navigate to={{ pathname: PATH.BASKET, search: utmQueryString() }} />} />
    </RouterRoutes>
  )
}
